import { createApp } from 'vue'
import { IonicVue } from '@ionic/vue'
import { createHead } from '@vueuse/head'
import App from './App.vue'
import router from './router'
import { StatusBar, Style } from '@capacitor/status-bar'
import '@ionic/vue/css/core.css'
import '@ionic/vue/css/normalize.css'
import '@ionic/vue/css/structure.css'
import '@ionic/vue/css/typography.css'
import '@ionic/vue/css/padding.css'
import '@ionic/vue/css/float-elements.css'
import '@ionic/vue/css/text-alignment.css'
import '@ionic/vue/css/text-transformation.css'
import '@ionic/vue/css/flex-utils.css'
import '@ionic/vue/css/display.css'
import './theme/global.css'
import './theme/variables.css'
import './assets/dashboard-ui.css'
import './assets/ion-alert-admin.css'
import './assets/admin-panel-theme.css'

import store from './store'

const app = createApp(App)
const head = createHead()
app.use(IonicVue)
app.use(store)
app.use(router)
app.use(head)

// Auto restore auth from localStorage on app start
store.dispatch('auth/initialize')

// Ensure browser tab title is consistent across all routes.
document.title = 'RiderFieldMotors'

router.isReady().then(async () => {
  // Configure native status bar (Android/iOS) so content goes under it
  try {
    await StatusBar.setOverlaysWebView({ overlay: true })
    await StatusBar.setBackgroundColor({ color: '#00000000' }) // transparent
    await StatusBar.setStyle({ style: Style.Light })
  } catch (e) {
    // Running in web or plugin not available; safely ignore
    console.warn('[StatusBar] configuration skipped:', e?.message || e)
  }

  app.mount('#app')
})
